import React from 'react';
import { IonCardTitle, IonCardContent } from '@ionic/react';

type Props = {
  passes: [],
  title: string,
};

const EntrancePasses: React.FC<Props> = ({ passes, title }) => {
  return (
    <div>
      <IonCardContent>
        <IonCardTitle>{title}</IonCardTitle>
        { passes.map((item: any, index: number) => {
            return (
              <div key={'passes'+index}>
                <div><b>{item.title}</b></div>
                <div>{item.description}</div>
                <li>${Number(item.cost).toFixed(2)}</li>
              </div>
            );
          })
        }
      </IonCardContent>
    </div>
  )
  
};

export default EntrancePasses;